import React, { useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Modal } from "react-bootstrap";
import {
    sortCaret,
    headerSortingClasses
} from "../../../../../../_metronic/_helpers";
import { format } from "date-fns";

const SelfAttendance = ({
    show,
    onHide,
    data = [],
    selectedType, isManagerView,
}) => {

    const attendanceStatusMap = {
        "Absent (Shift is yet to start)": "att-absent-att",
        "Absent (Off Day)": "att-absent-att",
        "Absent (Holiday)": "att-absent-att",
        "Absent": "att-absent-att",

        "H.D('LeaveCode') + H.D(A)": "att-HD",
        "H.D(P) + H.D(A)": "att-HD",
        "H.D(P) + H.D('LeaveCode')": "att-HD",
        "H.D(P)": "att-HD",

        "Holiday (H.D(Present))": "att-HD",
        "Day Off (H.D(Present))": "att-HD",

        "Holiday (Present)": "att-dayoff",
        "Day Off (Present)": "att-dayoff",
        "Day Off": "att-dayoff",
        "Holiday": "att-dayoff",

        "Present": "att-present",
        "Present (On-Time)": "att-present",

        "Present (On Time, Early-Out)": "att-presents",
        "Present (Early Out)": "att-presents",
        "Present (Late-In)(Holiday)": "att-presents",
        "Present (Late-In)(Day Off)": "att-presents",
        "Present (Late-In, Early-Out)": "att-presents",
        "Present (Late-In)": "att-presents",
        "Present (Missing Time Out)": "att-presents",
        "Present (Missing Time In)": "att-presents",
    };

    const tableData = useMemo(() => {
        return Array.isArray(data) ? data : [];
    }, [data]);
    const getAttendanceStatus = (row) => {

        if (row?.isHalfDay === 1) {
            return "H.D(P)";
        }

        if (row?.isHoliday === 1 && row?.status === "P") {
            return "Holiday (Present)";
        }

        if (row?.isOffDay === 1 && row?.status === "P") {
            return "Day Off (Present)";
        }

        if (row?.status === "A") {
            return "Absent";
        }

        if (row?.isLateComing === 1 && row?.isEarlyGoing === 1) {
            return "Present (Late-In, Early-Out)";
        }

        if (row?.isLateComing === 1) {
            return "Present (Late-In)";
        }

        if (row?.isEarlyGoing === 1) {
            return "Present (Early Out)";
        }

        if (row?.isOnTime === 1) {
            return "Present (On-Time)";
        }

        if (row?.status === "P" && !row?.timeOut) {
            return "Present (Missing Time Out)";
        }

        if (row?.status === "P" && !row?.timeIn) {
            return "Present (Missing Time In)";
        }

        if (row?.status === "P") {
            return "Present";
        }

        if (row?.status === "D") {
            return "Day Off";
        }

        if (row?.status === "H") {
            return "Holiday";
        }

        return row?.status || "-";
    };

    const columns = [
        ...(isManagerView
            ? [
                {
                    dataField: "employeeCode",
                    text: "Employee Code",
                    sort: true,
                    sortCaret,
                    headerSortingClasses,
                    style: {
                        textAlign: "left",
                    },
                    headerStyle: {
                        textAlign: "left",
                    },
                    formatter: (cell) => cell || "-",
                },
                {
                    dataField: "employeeName",
                    text: "Employee Name",
                    sort: true,
                    sortCaret,
                    headerSortingClasses,
                    style: {
                        textAlign: "left",
                    },
                    headerStyle: {
                        textAlign: "left",
                    },
                    formatter: (cell) => cell || "-",
                },
            ]
            : []),

        {
            dataField: "date",
            text: "Day & Date",
            sort: true,
            sortCaret,
            headerSortingClasses,
            style: {
                textAlign: "left",
            },
            headerStyle: {
                textAlign: "left",
            },
            formatter: (cell) => {
                if (!cell) return "-";

                const date = new Date(cell);
                if (isNaN(date.getTime())) return "-";

                return format(date, "EEE, dd-MMM-yyyy");
            },
        },
        {
            dataField: "timeIn",
            text: "In",
            sort: true,
            sortCaret,
            headerSortingClasses,
            style: {
                textAlign: "center",
            },
            headerStyle: {
                textAlign: "center",
            },
            formatter: (cell) => {
                if (!cell) return "-";

                const value = String(cell).padStart(4, "0");

                return `${value.slice(0, 2)}:${value.slice(2, 4)}`;
            },
        },
        {
            dataField: "timeOut",
            text: "Out",
            sort: true,
            sortCaret,
            headerSortingClasses,
            style: {
                textAlign: "center",
            },
            headerStyle: {
                textAlign: "center",
            },
            formatter: (cell) => {
                if (!cell) return "-";

                const value = String(cell).padStart(4, "0");

                return `${value.slice(0, 2)}:${value.slice(2, 4)}`;
            },
        },
        {
            dataField: "attDateOut",
            text: "Date Out",
            sort: true,
            sortCaret,
            headerSortingClasses,
            style: {
                textAlign: "center",
            },
            headerStyle: {
                textAlign: "center",
            },
            formatter: (cell) => {
                if (!cell) return "-";

                const date = new Date(cell);
                if (isNaN(date.getTime())) return "-";

                return format(date, "dd-MMM-yyyy");
            },
        },
        {
            dataField: "status",
            text: "Attendance Status",
            sort: true,
            sortCaret,
            headerSortingClasses,
            style: {
                textAlign: "left",
            },
            headerStyle: {
                textAlign: "left",
            },
            formatter: (cell) => {
                const statusClass = attendanceStatusMap[cell] || "";

                return (
                    <span className={statusClass}>
                        {cell || "-"}
                    </span>
                );
            },
        },
    ];

    return (

        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered

        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {"Attendance"} Detail
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="w-full overflow-auto max-h-[80dvh] scrollable mt-5">
                <BootstrapTable
                    responsive
                    noDataIndication={() => "No records found"}
                    wrapperClasses="table-responsive"
                    bordered={false}
                    classes="table table-head-custom table-vertical-center overflow-hidden table-hover"
                    bootstrap4
                    keyField="date"
                    data={tableData}
                    columns={columns}
                />
            </Modal.Body>
        </Modal>
    );
};

export default SelfAttendance;